import PropTypes from 'prop-types';
// @mui
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
//
import Scrollbar from 'src/components/scrollbar';
import { HEADER } from '../config-layout';
import { HeaderSimple as Header } from '../_common';

// ----------------------------------------------------------------------

export default function CompactLayout({ children }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100dvh', overflow: 'hidden' }}>
      <Header />
      <Box
        sx={{
          mt: { xs: `${HEADER.H_MOBILE + 1}px`, md: `${HEADER.H_DESKTOP + 1}px` },
          flex: '1 1 auto',
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        <Scrollbar sx={{ height: 1, '& .simplebar-content': { minHeight: '100%' } }}>
          <Container component="main" sx={{ minHeight: '100%' }}>
            <Stack
              sx={{
                py: 12,
                m: 'auto',
                maxWidth: 400,
                minHeight: '100%',
                textAlign: 'center',
                justifyContent: 'center',
              }}
            >
              {children}
            </Stack>
          </Container>
        </Scrollbar>
      </Box>
    </Box>
  );
}

CompactLayout.propTypes = {
  children: PropTypes.node,
};
